import { makeStyles } from '@mui/styles';

// colors
import { colors } from '../../../colors';

const chipBackColorArray = [
  colors.chipBackColor1,
  colors.chipBackColor2,
  colors.chipBackColor3,
  colors.chipBackColor4,
  colors.chipBackColor5,
];

const chipFontColorArray = [
  colors.chipFontColor1,
  colors.chipFontColor2,
  colors.chipFontColor3,
  colors.chipFontColor4,
  colors.chipFontColor5,
];

export const useStyles = makeStyles({
  root: {
    display: 'inline-flex',
    overflow: 'hidden',
  },
  drawerDateRangeWidth: {
    display: 'block !important',
  },
  rootForStartAdornment: {
    paddingLeft: '12px !important',
  },
  rootForEndAdornment: {
    paddingRight: '12px !important',
  },
  default: {
    height: 72,
    border: `1px solid ${colors.inputBorder}`,
    borderRadius: 4,
    padding: '12px 16px',
    '& .MuiInputAdornment-root.MuiInputAdornment-positionEnd': {
      marginRight: 0,
    },
    '& .MuiInputAdornment-root': {
      marginRight: 12,
    },
    '& .MuiInputLabel-root': {
      fontFamily: 'Manrope',
      fontWeight: 'bold',
      fontSize: 14,
      lineHeight: '19px',
      letterSpacing: '0.01em',
      color: colors.neutral900,
      left: 16,
      top: 12,
      transform: 'none',
    },
    '& .MuiInput-root': {
      flex: 1,
      '& > input': {
        padding: 0,
        fontFamily: 'Manrope',
        fontWeight: 500,
        fontSize: 16,
        lineHeight: 1.6,
        letterSpacing: '0.01em',
        color: colors.neutral900,
        '&::placeholder': {
          color: colors.neutral500,
        },
      },
      '&:before, &:after': {
        display: 'none',
      },
    },
    '& label + .MuiInput-root': {
      marginTop: 22,
    },
  },
  tags: {
    border: `1px solid ${colors.inputBorder}`,
    borderRadius: 4,
    padding: '12px 16px',
    '& .MuiInputBase-root': {
      padding: '0 !important',
      '& > .MuiChip-root': {
        height: 42,
        backgroundColor: colors.neutral300,
        '& > .MuiChip-label': {
          paddingLeft: 16,
          paddingRight: 10,
          fontFamily: 'Manrope',
          fontWeight: 500,
          fontSize: 16,
          color: colors.neutral900,
        },
        '& > .MuiChip-deleteIcon': {
          margin: '0 10px 0 0',
          color: colors.neutral500,
        },
      },
      '& > input': {
        margin: 3,
        padding: '0 8px !important',
        height: 42,
        color: colors.neutral900,
        fontFamily: 'Manrope',
        fontWeight: 500,
        fontSize: 16,
        '&::placeholder': {
          opacity: 1,
          color: colors.textLowContrast,
        },
      },
      '& > fieldset': {
        border: 'none',
      },
    },
  },
  search: {
    position: 'relative',
    '& .MuiTextField-root': {
      width: '100%',
      '& .MuiInputBase-root': {
        height: 64,
        paddingLeft: 18,
        fontFamily: 'Manrope',
        fontSize: 14,
        color: colors.textLowContrast,
        '& > .MuiInputAdornment-root': {
          marginRight: 14,
          '& > svg': {
            width: 18,
            height: 18,
          },
        },
        '& > input': {
          padding: 0,
          color: colors.neutral900,
          fontWeight: 500,
          '&::placeholder': {
            opacity: 1,
            color: colors.textLowContrast,
          },
        },
        '& > fieldset': {
          border: `1px solid ${colors.neutral400}`,
          borderRadius: 8,
        },
        '&:hover, &.Mui-focused': {
          '& > fieldset': {
            borderColor: colors.primary,
            borderWidth: 1,
          },
        },
        '&.Mui-focused': {
          '& > .MuiInputAdornment-root': {
            '& > svg path': {
              fill: colors.primary,
            },
          },
        },
      },
    },
  },
  searchClear: {
    cursor: 'pointer',
    position: 'absolute',
    right: 24,
    top: '50%',
    transform: 'translateY(-50%)',
    width: 20,
    height: 20,
    backgroundColor: colors.neutral500,
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    transition: '0.4s',
    '&:hover': {
      opacity: 0.8,
    },
    '& > svg': {
      width: 10,
      height: 10,
    },
  },
  sizeMedium: {
    height: 'auto',
    minHeight: 48,
    padding: '13px 16px',
    '& .MuiInput-root': {
      flex: 1,
      '& > input': {
        padding: 0,
        fontFamily: 'Manrope',
        fontWeight: 500,
        fontSize: 14,
        lineHeight: '20px',
        color: colors.neutral900,
        '&::placeholder': {
          color: colors.textLowContrast,
        },
      },
      '&:before, &:after': {
        display: 'none',
      },
    },
  },
  fullWidth: {
    width: '100% !important',
    flex: 1,
  },
  autoCompleteSizeMedium: {
    padding: '0px 0px !important',
    '& .MuiAutocomplete-inputRoot': {
      padding: '0 !important',
    },
    '& input': {
      boxSizing: 'border-box',
      padding: '14px 16px !important',
      height: 48,
      color: colors.neutral900,
      fontFamily: 'Manrope',
      fontSize: 14,
      fontWeight: 500,
      lineHeight: '20px',
      '&::placeholder': {
        opacity: 1,
        color: colors.textLowContrast,
      },
    },
    '& > fieldset': {
      border: 'none',
    },
  },
  tagSizeMedium: {
    padding: '0px 0px !important',
    '& .MuiInputBase-root': {
      borderRadius: 4,
      padding: '0 12px 0 8px !important',
      '& > .MuiChip-root': {
        position: 'relative',
        overflow: 'hidden',
        height: 28,
        marginTop: 9,
        marginBottom: 9,
        backgroundColor: 'transparent',
        border: `1px solid ${colors.primary300}`,
        '& > .MuiChip-label': {
          paddingLeft: 12,
          paddingRight: 12,
          paddingTop: 4,
          paddingBottom: 4,
          fontFamily: 'Manrope',
          fontWeight: 600,
          fontSize: 14,
          lineHeight: '20px',
          color: colors.primary600,
        },
        '& > .MuiChip-deleteIcon': {
          position: 'absolute',
          color: colors.neutral500,
          width: '100%',
          height: '100%',
          opacity: 0,
          margin: 0,
          top: 0,
          left: 0,
        },
      },
      '& > input': {
        margin: 0,
        padding: '2px 8px !important',
        height: 42,
        color: colors.neutral900,
        fontFamily: 'Manrope',
        fontWeight: 500,
        fontSize: 16,
        '&::placeholder': {
          opacity: 1,
          color: colors.textLowContrast,
        },
      },
      '& > fieldset': {
        border: 'none',
      },
    },
  },
  phoneInputStyle: {
    width: '100% !important',
    height: '48px !important',
    paddingLeft: '82px !important',
    borderColor: `${colors.neutral200} !important`,
  },
  phoneButtonStyle: {
    border: `1px solid ${colors.neutral200} !important`,
    paddingLeft: '8px !important',
    paddingRight: '24px !important',
    backgroundColor: `${colors.neutral25} !important`,
    '& .selected-flag': {
      '& .flag': {
        transform: 'scale(1.425)',
      },
      '& .arrow': {
        left: '25px !important',
        borderLeft: '3.75px solid transparent !important',
        borderRight: '3.75px solid transparent !important',
        borderTop: `4.75px solid ${colors.neutral600} !important`,
        '&.up': {
          borderTop: `none !important`,
          borderBottom: `4.75px solid ${colors.neutral600} !important`,
        },
      },
    },
  },
  inputChipColor: {
    '& .MuiInputBase-root': {
      '& > .MuiChip-root': {
        border: 'none',
      },
      '& > .MuiChip-root:nth-of-type(5n+1)': {
        backgroundColor: chipBackColorArray[0],
        '& > .MuiChip-label': {
          color: chipFontColorArray[0],
        },
      },
      '& > .MuiChip-root:nth-of-type(5n+2)': {
        backgroundColor: chipBackColorArray[1],
        '& > .MuiChip-label': {
          color: chipFontColorArray[1],
        },
      },
      '& > .MuiChip-root:nth-of-type(5n+3)': {
        backgroundColor: chipBackColorArray[2],
        '& > .MuiChip-label': {
          color: chipFontColorArray[2],
        },
      },
      '& > .MuiChip-root:nth-of-type(5n+4)': {
        backgroundColor: chipBackColorArray[3],
        '& > .MuiChip-label': {
          color: chipFontColorArray[3],
        },
      },
      '& > .MuiChip-root:nth-of-type(5n+5)': {
        backgroundColor: chipBackColorArray[4],
        '& > .MuiChip-label': {
          color: chipFontColorArray[4],
        },
      },
    },
  },
  searchInput: {
    '& input': {
      paddingRight: '50px !important',
    },
  },
  calendarFilter: {
    flex: 'initial !important',
    minWidth: 'initial !important',
    position: 'relative',
    '& .calendarFilterInner': {
      display: 'flex',
      gap: 16,
      height: 48,
      alignItems: 'center',
      borderRadius: 4,
      backgroundColor: '#fff',
      '& .MuiTextField-root': {
        width: '100%',
        '& .MuiInputLabel-root': {
          display: 'none',
        },
        '& .MuiInputBase-root': {
          height: 48,
          paddingLeft: 18,
          marginTop: 0,
          fontFamily: 'Manrope',
          fontSize: 14,
          color: colors.textLowContrast,
          border: `1px solid ${colors.neutral400}`,
          borderRadius: 4,
          '&::before, &::after': {
            display: 'none',
          },
          '& > .MuiInputAdornment-root': {
            marginRight: 14,
            '& .MuiIconButton-root': {
              display: 'none',
            },
            '& > svg': {
              width: 18,
              height: 18,
            },
          },
          '& > input': {
            padding: 0,
            color: colors.neutral900,
            fontWeight: 500,
            '&::placeholder': {
              opacity: 1,
              color: colors.textLowContrast,
            },
          },
          '&.Mui-focused': {
            borderColor: colors.primary,
            '& > .MuiInputAdornment-root': {
              '& > svg path': {
                fill: colors.primary,
              },
            },
          },
        },
      },
    },
  },
});
